import { CHCHeaderLanguage } from "./header-language.component.js";
customElements.define("chc-header-language", CHCHeaderLanguage);
export {
  CHCHeaderLanguage
};
//# sourceMappingURL=header-language.js.map
